import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../../utils/api';
import Card from '../UI/Card';
import Button from '../UI/Button';
import Badge from '../UI/Badge';

export default function QuizList({ userRole }) {
  const { courseId } = useParams();
  const navigate = useNavigate();
  const [quizzes, setQuizzes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (courseId) {
      fetchQuizzes();
    }
  }, [courseId]);

  const fetchQuizzes = async () => {
    try {
      setLoading(true);
      const response = await api.get(`/api/quizzes/course/${courseId}`);
      setQuizzes(response.data.quizzes || []);
    } catch (err) {
      setError(err.response?.data?.error || '퀴즈 목록을 불러올 수 없습니다.');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center py-12">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-500"></div>
      </div>
    );
  }

  if (error) {
    return (
      <Card className="text-center py-8">
        <p className="text-danger-500 mb-4">{error}</p>
        <Button onClick={fetchQuizzes}>다시 시도</Button>
      </Card>
    );
  }

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h2 className="text-2xl font-bold text-neutral-800">퀴즈</h2>
        {userRole === 'TEACHER' && (
          <Button onClick={() => navigate(`/courses/${courseId}/quizzes/create`)}>
            새 퀴즈 만들기
          </Button>
        )}
      </div>

      {quizzes.length === 0 ? (
        <Card className="text-center py-12">
          <p className="text-neutral-500 mb-4">
            {userRole === 'TEACHER'
              ? '아직 생성된 퀴즈가 없습니다.'
              : '응시할 퀴즈가 없습니다.'}
          </p>
          {userRole === 'TEACHER' && (
            <Button onClick={() => navigate(`/courses/${courseId}/quizzes/create`)}>
              퀴즈 만들기
            </Button>
          )}
        </Card>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {quizzes.map((quiz) => (
            <Card
              key={quiz.id}
              hover
              className="cursor-pointer animate-fade-in"
              onClick={() => navigate(`/courses/${courseId}/quizzes/${quiz.id}`)}
            >
              <div className="flex items-start justify-between mb-3">
                <h3 className="text-lg font-bold text-neutral-800 flex-1">
                  {quiz.title}
                </h3>
                <Badge variant="primary">
                  {quiz.questions?.length || 0}문제
                </Badge>
              </div>

              {quiz.description && (
                <p className="text-sm text-neutral-600 mb-4 line-clamp-2">
                  {quiz.description}
                </p>
              )}

              <div className="flex items-center justify-between text-sm text-neutral-500">
                <div className="flex items-center gap-4">
                  {quiz.timeLimit && (
                    <span>제한시간: {quiz.timeLimit}분</span>
                  )}
                </div>
                {userRole === 'TEACHER' && quiz._count && (
                  <span>{quiz._count.submissions || 0}명 응시</span>
                )}
              </div>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
